import { get as getBrowse } from "#skyward_browse";
import { getBrowseById, getCurrentBrowseName } from "#skyward_browseList";
import { virtualDir } from "#skyward_global";
import { loadContent } from "#skyward_window";
import { registerEvents } from "./skyward.ui.events";
import { JQueryInput } from "./types";

const classNames =
{
    sortable: "sortable",
    show: "show",
    hide: "hide",
};

interface DockData
{
    primarykeyid: string;
    [key: string]: string;
}

const dockBar = $("#dockBar");
const dockBarInnerContainer = $('#dockBarInnerContainer');
let displayDockToolbar = dockBar.hasClass(classNames.show);

const events =
{
    init,
    click: dockButtonClick,
    add: addToDock,
    edit: editDock,
};

registerEvents("dock", events);

function init(this: JQueryInput)
{
    const dock = $(this);

    const sortableOptions =
    {
        cursor: "move",
        scroll: true,
        containment: "parent",
        items: `> .${classNames.sortable}`,
        tolerance: "pointer",
        distance: 5,
        start: function (_event: any, ui: any)
        {
            ui.item[0].oldclick = ui.item[0].onclick;
            ui.item[0].onclick = null;
        },
        stop: function (_event: any, ui: any)
        {
            setTimeout(function ()
            {
                ui.item[0].onclick = ui.item[0].oldclick;
            }, 500);
        },
        update: function ()
        {
            updateDock();
        }
    };

    dockBarInnerContainer.sortable(sortableOptions);
    dockBarInnerContainer.disableSelection();

    dock.debounce("click", saveDockState);
}

function saveNewDockItem()
{
    return $.ajax(
    {
        url: `${virtualDir}SkySys/UserDock/AddToDock`,
        type: "POST",
        dataType: "viewparthtml",
        data:
        {
            DisplayOrder: dockBarInnerContainer[0].children.length - 1,
            ScreenFriendlyName: $("#friendlyNameContents").text()
        }
    }).promise();
}

function addToDock(this: JQueryInput): JQuery.Promise<any>
{
    const button = $(this);
    button.hide();
    return saveNewDockItem().done(function (data)
    {
        dockBarInnerContainer.append(data);
        refreshIfCurrentScreenIsDockList();
    });
}

function editDock(this: JQueryInput): JQuery.Promise<any>
{
    updateDock();
    return showReorderList();
}

function showReorderList()
{
    return loadContent('full', 'SkySys', 'UserDock', 'List', null, null);
}

function updateDock(): JQuery.Promise<any>
{
    const dockItems: Record<string, number> = {};
    let index = 1;
    dockBarInnerContainer.children(`.${classNames.sortable}`).each(function ()
    {
        const dockData = $(this).data() as DockData;
        if (dockData)
        {
            dockItems[dockData.primarykeyid] = index;
            index++;
        }
    });

    return $.ajax(
    {
        url: `${virtualDir}SkySys/UserDock/UpdateDock`,
        type: "POST",
        dataType: "JSON",
        data:
        {
            DockItems: JSON.stringify(dockItems)
        },
        success: refreshIfCurrentScreenIsDockList,
    }).promise();
}

function refreshIfCurrentScreenIsDockList()
{
    const browseName = getCurrentBrowseName();
    const browse = getBrowseById(browseName);
    if (browse && browse.routeModule === "SkySys" && browse.routeObject === "UserDock")
    {
        getBrowse("browse");
    }
}

function dockButtonClick(this: JQueryInput)
{
    const dockButton = $(this);
    if (displayDockToolbar)
    {
        hideDock.apply(dockButton)
    } else {
        showDock.apply(dockButton)
    }

    dockButton.attr("aria-expanded", displayDockToolbar as unknown as string);
    $(window).trigger("resize");
}

function hideDock(this: JQuery<HTMLElement>)
{
    dockBar.removeClass(classNames.show).addClass(classNames.hide);
    this.removeClass(classNames.show).addClass(classNames.hide);
    displayDockToolbar = false;
}

function showDock(this: JQuery<HTMLElement>)
{
    dockBar.removeClass(classNames.hide).addClass(classNames.show);
    this.removeClass(classNames.hide).addClass(classNames.show);
    displayDockToolbar = true;
}

function saveDockState()
{
    return $.ajax(`${virtualDir}SkySys/UserDock/UpdateDockDisplay`,
        {
            type: "POST",
            dataType: "JSON",
            activityIndicator: { hideGlass: true },
            data: { showDockToolbar: displayDockToolbar }
        }).promise();
}
